const locations = [
  {
    name: '本社（天神屋 買取受付）',
    type: '出張買取専門',
    address: '〒810-0075 福岡県福岡市中央区港1-2-18-1712',
    tel: '092-577-9739',
    email: 'info@botan-buy.com',
    note: '※ 店舗での買取は行っておりません。出張買取のみ対応しております。',
    mapQuery: '福岡県福岡市中央区港1丁目2',
    icon: 'ri-building-2-line',
    color: 'bg-primary',
  },
  {
    name: 'カードショップ まんがく',
    type: '店舗営業',
    address: '香川県高松市瓦町2-1-28 高尾ビル2F南',
    tel: '',
    email: '',
    note: '※ 店頭にてカードの買取・販売を行っております。',
    mapQuery: '香川県高松市瓦町2丁目1-28',
    icon: 'ri-store-3-line',
    color: 'bg-accent',
  },
];

export default function Locations() {
  return (
    <section id="locations" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-primary font-medium uppercase mb-3">Locations</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-4">店舗情報</h2>
          <div className="w-16 h-0.5 bg-primary/30 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {locations.map((loc) => (
            <div key={loc.name} className="rounded-2xl overflow-hidden border border-gray-100">
              {/* Map */}
              <div className="h-64 w-full">
                <iframe
                  title={loc.name}
                  src={`https://www.google.com/maps?q=${encodeURIComponent(loc.address)}&output=embed`}
                  className="w-full h-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* Info */}
              <div className="p-7">
                <div className="flex items-start gap-4 mb-5">
                  <div className={`w-10 h-10 flex items-center justify-center ${loc.color} rounded-full flex-shrink-0`}>
                    <i className={`${loc.icon} text-white text-sm`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 text-lg leading-snug">{loc.name}</h3>
                    <span className="text-xs text-white bg-primary px-2.5 py-0.5 rounded-full mt-1 inline-block">{loc.type}</span>
                  </div>
                </div>

                <div className="flex flex-col gap-3 text-sm">
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-primary"></i>
                    </div>
                    <span className="text-gray-600">{loc.address}</span>
                  </div>
                  {loc.tel && (
                    <div className="flex items-center gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-primary"></i>
                      </div>
                      <a href={`tel:${loc.tel}`} className="text-gray-600 hover:text-primary cursor-pointer">{loc.tel}</a>
                    </div>
                  )}
                  {loc.email && (
                    <div className="flex items-center gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-primary"></i>
                      </div>
                      <a href={`mailto:${loc.email}`} className="text-gray-600 hover:text-primary cursor-pointer">{loc.email}</a>
                    </div>
                  )}
                </div>

                {loc.note && (
                  <p className="mt-4 text-xs text-gray-400 bg-gray-50 rounded-lg px-4 py-3 leading-relaxed">{loc.note}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
